module.exports = __webpack_public_path__ + "img/lxwm.188ee097.png";